module.exports = __webpack_public_path__ + "static/media/siperficie boton.21c56e6a.png";